export default "__VITE_ASSET__CyI1fjZ___"